var _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlowLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1,
    height: 36,
    viewBox: "0 0 1 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0.499954,
    y1: 35.5,
    x2: 0.500054,
    y2: 0.5,
    stroke: "#9CA0A5",
    strokeLinecap: "square",
    strokeDasharray: "3 3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowLine);
export default __webpack_public_path__ + "static/media/flowLine.7e6b8ed3382c73016c5d538c5bc11951.svg";
export { ForwardRef as ReactComponent };